import type { LeaderboardEntry } from '../ui/Leaderboard';

interface PlayerSnapshot {
  sessionId: string;
  username: string;
  score: number;
  kills: number;
  droneCount: number;
  alive: boolean;
}

export class PlayerStateTracker {
  private leaderboard: LeaderboardEntry[] = [];
  private localPlayer: PlayerSnapshot | null = null;

  syncFromState(state: { players?: Map<string, PlayerSnapshot> }, localSessionId: string): void {
    this.leaderboard = [];
    this.localPlayer = null;

    if (!state?.players) return;

    state.players.forEach((player: PlayerSnapshot) => {
      const isLocal = player.sessionId === localSessionId;
      this.leaderboard.push({
        username: player.username,
        score: player.score,
        kills: player.kills,
        droneCount: player.droneCount,
        isLocal,
      });
      if (isLocal) {
        this.localPlayer = player;
      }
    });

    this.leaderboard.sort((a, b) => b.score - a.score);
  }

  getLeaderboard(): LeaderboardEntry[] {
    return this.leaderboard;
  }

  getLocalPlayer(): PlayerSnapshot | null {
    return this.localPlayer;
  }

  isLocalPlayerDead(): boolean {
    return this.localPlayer ? !this.localPlayer.alive : false;
  }
}
